interface LDApplicationInfo {
  id: string
  version: string | undefined
}

/**
 * Application metadata for both LaunchDarkly SDKs. They send it as the `application-id` and
 * `application-version` request tags LaunchDarkly attributes flag traffic by, which is what
 * populates the Applications page and the group-by-application breakdown on flag insights.
 *
 * Mirrors Datadog RUM's `service` and `version` for the same build deliberately, so a flag
 * evaluation and a RUM session resolve to one release — keep the two in step.
 *
 * `version` is undefined outside a Vercel build, and in Storybook and tests. Both SDKs skip a
 * falsy version, so leave it unset: a coerced `"undefined"` satisfies their tag charset check and
 * would be recorded as a genuine version.
 */
export const getLDApplicationInfo = (): LDApplicationInfo => ({
  id: 'settle-web',
  version: process.env.SHORT_SHA,
})
